import { render, staticRenderFns } from "./BtnBig.vue?vue&type=template&id=21662f53&"
import script from "./BtnBig.vue?vue&type=script&lang=js&"
export * from "./BtnBig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports